<template>
  <button
    v-bind="$attrs"
    type="button"
    class="button is-primary"
    :class="{ 'is-loading': loading }"
    :disabled="loading || undefined"
    v-on:click="toggleModal"
  >
    Create
  </button>
  <Modal
    is-large
    v-model="modal"
    title="New secret"
  >
    <form v-on:submit.prevent="performCreate">
      <div class="field">
        <label class="label">Name</label>
        <div class="control">
          <input
            autofocus
            class="input"
            :class="{ 'is-danger': errors.name }"
            type="text"
            placeholder="Secret name"
            v-model.trim="name"
            required
          />
        </div>
        <p
          class="help is-danger"
          v-if="errors.name"
        >
          {{ errors.name }}
        </p>
      </div>
      <div class="field">
        <label class="label">Content</label>
        <div class="control">
          <textarea
            class="textarea"
            :class="{ 'is-danger': errors.content }"
            type="text"
            placeholder="Secret contents"
            v-model.trim="content"
            required
          ></textarea>
        </div>
        <p
          class="help is-danger"
          v-if="errors.content"
        >
          {{ errors.content }}
        </p>
      </div>
    </form>
    <template v-slot:footer="{ close }">
      <button
        class="button"
        v-on:click="close"
      >
        Cancel
      </button>
      <button
        class="button is-primary"
        :class="{ 'is-loading': loading }"
        :disabled="!canCreate || undefined"
        :title="buttonTitle"
        v-on:click="performCreate"
      >
        Create
      </button>
    </template>
  </Modal>
</template>

<script lang="ts">
import { isAxiosError } from 'axios'
import { mapStores } from 'pinia'
import { defineComponent } from 'vue'

import Modal from '@/components/Modal.vue'
import { errorParser } from '@/helpers'
import { useNotificationStore, useSecretStore } from '@/stores'

export default defineComponent({
  components: {
    Modal,
  },
  data: () => ({
    loading: false,
    modal: false,
    name: '',
    content: '',
    errors: {} as Record<string, string | undefined>,
  }),
  computed: {
    ...mapStores(useSecretStore),
    canCreate(): boolean {
      return !this.loading && this.name !== '' && this.content !== ''
    },
    buttonTitle(): string {
      if (this.loading) return 'Loading…'
      if (!this.canCreate) return 'The name and content must not be empty'
      return 'Create a new secret'
    },
  },
  methods: {
    toggleModal() {
      this.modal = !this.modal
    },
    async performCreate() {
      if (this.loading || !this.canCreate) return
      this.loading = true
      this.errors = {}
      try {
        await this.secretStore.create({ name: this.name, content: this.content })
        this.modal = false
        this.$router.push({ name: 'secret-details', params: { name: this.name.split('/') } })
      } catch (err) {
        useNotificationStore().notify({ type: 'error', text: errorParser(err) })
        if (isAxiosError(err) && typeof err.response?.data === 'object') {
          for (const key of ['name', 'content']) {
            if (err.response.data[key]) this.errors[key] = errorParser(err.response.data[key])
          }
        }
      } finally {
        this.loading = false
      }
    },
  },
})
</script>
